import { AuthContext } from "context"
import { DOCUMENT_PATH, REPORT_RECEIVED_PATH, SEND_PATH } from "lib"
import { DocumentReceivedReports } from "pages"
import React from "react"
import { Route } from "react-router-dom"

const ReportsReceived = () => {
  const { user } = React.useContext(AuthContext)
  return (
    <React.Fragment>
      {Boolean(user) && (
        <React.Fragment>
          <Route
            strict
            path={`${REPORT_RECEIVED_PATH}${SEND_PATH}${DOCUMENT_PATH}`}
            component={DocumentReceivedReports}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export default ReportsReceived
